import React from 'react';
import PropTypes from 'prop-types';
import {Checkbox, FormControl, FormControlLabel, FormHelperText} from '@material-ui/core';
import useStyles from './CheckBoxStyles';

const CheckBox = ({label, labelPlacement, formControlLabelValue, checkboxValue, checked, disabled, onChange, formControlLabelProps, error, helperText, ...props}) => {

    const classes = useStyles();

    return (
        <FormControl disabled={disabled} error={error}>
            <FormControlLabel
                disabled={disabled}
                onChange={onChange}
                control={
                    <Checkbox
                        value={checkboxValue}
                        checked={checked}
                        classes={classes}
                        {...props}
                    />
                }
                value={formControlLabelValue}
                label={label}
                labelPlacement={labelPlacement}
                {...formControlLabelProps}
            />
            {helperText && (
                <FormHelperText>
                    {helperText}
                </FormHelperText>
            )}
        </FormControl>
    );
};

CheckBox.propTypes = {
    label: PropTypes.node,
    labelPlacement: PropTypes.oneOf(['bottom', 'top', 'start', 'end']),
    formControlLabelValue: PropTypes.any,
    checkboxValue: PropTypes.any,
    checked: PropTypes.bool,
    disabled: PropTypes.bool,
    onChange: PropTypes.func,
    className: PropTypes.string,
    formControlLabelProps: PropTypes.object,
    error: PropTypes.bool,
    helperText: PropTypes.node,
    checkedIcon: PropTypes.node,
    classes: PropTypes.object,
    color: PropTypes.oneOf(['default', 'primary', 'secondary']),
    disableRipple: PropTypes.bool,
    icon: PropTypes.node,
    id: PropTypes.string,
    indeterminate: PropTypes.bool,
    indeterminateIcon: PropTypes.node,
    inputProps: PropTypes.object,
    inputRef: PropTypes.any,
    required: PropTypes.bool,
    size: PropTypes.oneOf(['medium', 'small']),
    value: PropTypes.any,
};

CheckBox.defaultProps = {
    label: '',
    labelPlacement: 'end',
    formControlLabelValue: '',
    checkboxValue: '',
    checked: false,
    disabled: false,
    onChange: e => console.log(JSON.stringify(e.target.checked)),
    className: '',
    formControlLabelProps: {},
    error: false,
    helperText: '',
};

export default CheckBox;